export default class RequestRateLimiter {
  constructor(period = 510) {
    this.initialPeriod = period;
    this.period = this.initialPeriod;
    this.tasks = [];
    this.running = false;
    this.interval = undefined;
    this.backedOff = false;
  }
  
  __checkQueue__() {
    if (this.running && this.tasks && this.tasks.length > 0) {
      this.tasks.shift()();
    } else {
      clearInterval(this.interval);
      this.running = false;
    }
  }
  
  request(url, options) {
    return new Promise((resolve) => {
      this.tasks.push(() => fetch(url, options)
        .then((res) => {
          if (res.status === 429) {
            this.backOff();
            resolve(this.request(url, options));
          } else {
            if (this.backedOff) {
              this.backOn();
            }
            resolve(res);
          }
        }));
  
      if (!this.running) {
        this.running = true;
        this.interval = setInterval(() => this.__checkQueue__(), this.period);
      }
    });
  }

  backOff() {
    this.backedOff = true;
    this.period *= 2;
    if (this.interval) {
      this.running = false;
      clearInterval(this.interval);
    }
  }

  backOn() {
    const oldPeriod = this.period;
    if (this.period / 1.5 > this.initialPeriod) {
      this.period /= 1.5;
    } else {
      this.period = this.initialPeriod;
      this.backedOff = false;
    }

    if (this.interval && this.period !== oldPeriod) {
      this.running = false;
      clearInterval(this.interval);
      this.running = true;
      this.interval = setInterval(() => this.__checkQueue__(), this.period);
    }
  }
}